import React from 'react';
import moment from 'moment';

function TimerList({
  currentPageData,
  timer,
  isTimerDataLoading,
  selectedUser,
  leastDate,
  highestDate,
  leastLastWeekDate,
  highestLastWeekDate,
  thisWeekRendered,
  WeekTotalDisplay,
  lastWeekRendered,
  getMomentDate,
  extremesByWeek,
  findLeastDate,
  findExtremeDate,
  TimerCard,
  resumeTimeTracking,
  appSettings,
  resumeLoading,
  customeTime,
  ThreeDots,
  Modal,
  taskModalIsOpen,
  setTaskModalIsOpen,
  taskName,
  setTaskName,
  showingDropdownRef,
  setShowingDropdownOpen,
  showingDropdownOpen,
  totalResults,
  perPage,
  setPerPage,
  setSelectedPage,
  pageCount,
  ReactPaginate,
  selectedPage,
  handlePageChange

}) {
  return (
    <>
      {timer.length > 0 ? (
        currentPageData.map((item, index) => (
          <div>
            {
              moment(moment(moment.tz(item[0], global.config.getTimeZone()).format("YYYY-MM-DD")).toDate()).isBetween(
                moment(leastDate).startOf("day").toDate(),
                moment(highestDate).endOf("day").toDate(),
                null,
                "[]"
              ) && !thisWeekRendered && (
                (thisWeekRendered = true),
                <div>
                  {timer.length > 0 ? (
                    <div className="total-time-tracked">
                      <div className="total-time-date-left">This Week</div>
                      <div className="total-time-date-right">
                        Week Total:
                        <WeekTotalDisplay
                          startDate={moment.tz(leastDate, global.config.getTimeZone()).startOf("day").toDate()}
                          endDate={moment.tz(highestDate, global.config.getTimeZone()).endOf("day").toDate()}
                          selectedUser={selectedUser}
                        />
                      </div>
                    </div>
                  ) : isTimerDataLoading ? (
                    <></>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            {
              moment(moment(moment.tz(item[0], global.config.getTimeZone()).format("YYYY-MM-DD")).toDate()).isBetween(
                moment(leastLastWeekDate).startOf("day"),
                moment(highestLastWeekDate).endOf("day"),
                null,
                "[]"
              ) && !lastWeekRendered && (
                (lastWeekRendered = true),
                <div>
                  {timer.length > 0 ? (
                    <div className="total-time-tracked">
                      <div className="total-time-date-left">Last Week</div>
                      <div className="total-time-date-right">
                        Week Total: <WeekTotalDisplay
                          startDate={getMomentDate(moment(leastLastWeekDate && leastLastWeekDate).toDate())}
                          endDate={getMomentDate(moment(highestLastWeekDate && highestLastWeekDate).toDate())}
                          selectedUser={selectedUser}
                        />
                      </div>
                    </div>
                  ) : isTimerDataLoading ? (
                    <></>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            {extremesByWeek.some(
              (extreme) =>
                moment.tz(extreme.highestWeekDate, global.config.getTimeZone()).format("YYYY-MM-DD") ===
                moment.tz(item[0], global.config.getTimeZone()).format("YYYY-MM-DD")
            ) &&
              moment(item[0]).format("YYYY-MM-DD") !==
              moment(highestDate).format("YYYY-MM-DD") &&
              moment(item[0]).format("YYYY-MM-DD") !==
              moment(highestLastWeekDate).format("YYYY-MM-DD") && (
                <div className="total-time-tracked">
                  <div className="total-time-date-left">
                    {` ${moment(findLeastDate(moment(item[0]).toDate(), extremesByWeek)).format("MMM D")} - 
            ${moment(findExtremeDate(moment(item[0]).toDate(), extremesByWeek)).format("MMM D")}`}
                    {moment(item[0]).year() !== moment().year() && (
                      <span>
                        <span>,</span> {moment(item[0]).year()}
                      </span>
                    )}
                  </div>

                  <div className="total-time-date-right">
                    Week Total:
                    <WeekTotalDisplay
                      selectedUser={selectedUser}
                      startDate={getMomentDate(findLeastDate(moment(item[0]).toDate(), extremesByWeek), "ddd MMM DD YYYY")}
                      endDate={getMomentDate(findExtremeDate(moment(item[0]).toDate(), extremesByWeek), "ddd MMM DD YYYY")}
                    />
                  </div>
                </div>
              )}

            <TimerCard
              index={index}
              item={item}
              resumeTimeTracking={resumeTimeTracking}
              timeFormat={appSettings.timeFormat}
              resumeLoading={resumeLoading}
              customeTime={customeTime}
              selectedUser={selectedUser}
            />
          </div>
        ))
      ) : isTimerDataLoading === true ? (
        <div className="outter-load-table">
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#405BFF"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      ) : (
        <div className="center-text">No Results</div>
      )}

      <Modal
        isOpen={taskModalIsOpen}
        onRequestClose={() => setTaskModalIsOpen(false)}
      >
        <h5>Task</h5>
        <input
          type="text"
          placeholder="What are you working on?"
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
          autocomplete="off"
        />
        <button onClick={() => setTaskModalIsOpen(false)}>Close Modal</button>
      </Modal>
      <div className="pagination-outer">
        <div class="showing-count">
          {!isTimerDataLoading && timer.length > 0 && (
            <div class="filter-inner showing-result">
              <label>Showing</label>
              <div
                ref={showingDropdownRef}
                className="select-modal-mainM custom-dropdown-user-new-outer"
              >
                <div
                  className="selected-option custom-dropdown-user-new"
                  onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}
                >
                  {totalResults < 10 ? totalResults.toString() : perPage.toString()}
                </div>
                {showingDropdownOpen && (
                  <div className="custom-dropdown-new">
                    <ul className="showing-options-list">
                      {[10, 20, 30, 40].map((num) =>
                        totalResults >= num ? (
                          <li
                            key={num}
                            className={perPage === num ? "selected-item" : ""}
                            onClick={() => {
                              setPerPage(num);
                              setSelectedPage(0);
                              setShowingDropdownOpen(false);
                            }}
                          >
                            {num}
                          </li>
                        ) : null
                      )}

                      {totalResults >= 10 && (
                        <li
                          className={perPage === totalResults ? "selected-item" : ""}
                          onClick={() => {
                            setPerPage(totalResults);
                            setSelectedPage(0);
                            setShowingDropdownOpen(false);
                          }}
                        >
                          ALL
                        </li>
                      )}

                      {totalResults < 10 && (
                        <li
                          className="selected-item"
                          onClick={() => {
                            setPerPage(totalResults);
                            setSelectedPage(0);
                            setShowingDropdownOpen(false);
                          }}
                        >
                          {totalResults}
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
              <label>of {totalResults} Results</label>
            </div>
          )}

        </div>
        <div className="pagination">
          {!isTimerDataLoading && pageCount > 1 && (
            <ReactPaginate
              previousLabel={selectedPage > 0 ? "< Back" : null}
              nextLabel={selectedPage < pageCount - 1 ? "Next >" : null}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={handlePageChange}
              containerClassName={"pagination maininteampag"}
              activeClassName={"active"}
              forcePage={selectedPage}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default TimerList